import varCommon from '@/utils/varCommon'
import { Notification } from 'element-ui';

export default {
  methods: {
    /* 时间日期选择器的快速选项设置
      [{ dateType: 1, midnight: true }, ...]
    */
    getPickerOptions(options) {
      let newArr = [],
        text = ''
      options.forEach(res => {
        const start = new Date();
        const end = new Date();
        start.setHours(0, 0, 0);
        end.setHours(0, 0, 0);
        switch (res.dateType) {
          case 'today':
            text = '今天';
            if (res.midnight) {
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
            }
            break;
          case 'yesterday':
            text = '昨天';
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            if (!res.midnight) {
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            }
            break;
          case 'oneWeek':
            text = '一周前';
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            break;
          case 'oneMonth':
            text = '30 天前';
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            break;
        }
        if (!res.midnight) {
          end.setHours(23, 59, 59, 999);
        }
        newArr.push({
          text,
          onClick(picker) {
            picker.$emit("pick", [start, end]);
          },
        });
      })
      return newArr;
    },
    // 将「秒数」转换为 天, 小时, 分, 秒
    HandleTimeStampToDatetimeFormat(time, type) {
      if (!time) return "-";
      let t = Number(time);
      let d = Math.floor(t / 86400);
      let h = Math.floor((t % 86400) / 3600);
      let m = Math.floor((t % 3600) / 60);
      let s = Math.floor((t % 3600) % 60);
      let dDisplay = d > 0 ? d + " 天 " : "";
      let hDisplay = h > 0 ? h + " 小时 " : "";
      let mDisplay = m > 0 ? m + " 分 " : "";
      let sDisplay = s > 0 ? s + " 秒" : "";
      if (type === 'day') {
        return dDisplay + hDisplay + mDisplay + sDisplay;
      } else {
        return hDisplay + mDisplay + sDisplay;
      }
    },
    // 根据用户回传中文类型
    translateUserType(userType) {
      switch (userType) {
        case 'super_admin':
          return '超级管理员';
        case 'top_agent':
          return '顶级代理';
        case 'admin':
          return '管理员';
        case 'seller':
          return '商户';
        case 'agent':
          return '代理';
        case 'finance':
          return '财务';
        case 'customer':
          return '客服';
        case 'operator':
          return '操作员';
        case 'switchboard':
          return '总机';
        case 'operator_admin':
          return '操作员管理员';
        case 'wallet_provider':
          return '钱包提供者';
        case 'wallet_admin':
          return '钱包管理员';
        default:
          return userType;
      }
    },
    // 根据退款状态返回对应 html
    translateRefundStatusHTML(status) {
      switch (status) {
        case 0: // 未发起
          return `<span style="color: #00A600;">${varCommon.refundStatus[status]}</span>`;
        case 1: // 申请退款
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 2: // 退款中
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 3: // 退款完成
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 4: // 退款失败
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 5: // 拒绝退款
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 99: // 申请直接退款
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 100: // 直接退款成功
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        default:
          return;
      }
    },
    // 显示小数点
    formatDecimalSeparator(number, decimals) {
      return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
    },
    // 显示千分位分隔符和小数点
    formatNumberWithCommasAndDecimalSeparator(number, decimals = 0) {
      let num = this.formatDecimalSeparator(number, decimals)
      return this.NumberWithCommas(num)
    },
    // 显示层级
    formatUserNamePathTooltip(userNamePath) {
      if (userNamePath) {
        let userNamePathArray = userNamePath.split('/');
        let returnResult = '';
        userNamePathArray.forEach(function (item, index) {
          if (index !== 0) { // 最顶部不要显示
            if (index === userNamePathArray.length - 1) {
              returnResult += `<span style="color: #b8b8b8;"><i class="username-path-location-animation el-icon-location-information"></i> ${item} </span>`;
            } else {
              returnResult += `<span>[ ${item} ]</span>`;
            }
            if (index !== userNamePathArray.length - 1) { // 显示箭头
              returnResult += '&nbsp;&nbsp;<i class="el-icon-right"></i>&nbsp;&nbsp;';
            }
          }
        });
        return returnResult ? returnResult : '<span style="color: #b8b8b8;">无上级</span>';
      } else {
        return '<span style="color: #b8b8b8;">无上级</span>';
      }
    },
    // 显示层级不需要 html 版本
    formatPureUserNamePathTooltip(userNamePath) {
      if (userNamePath) {
        let userNamePathArray = userNamePath.split('/');
        let returnResult = '';
        userNamePathArray.forEach(function (item, index) {
          if (index !== 0) { // 最顶部不要显示
            returnResult += item;
            if (index !== userNamePathArray.length - 1) { // 显示箭头
              returnResult += '/';
            }
          }
        });
        return returnResult ? returnResult : '无上级';
      } else {
        return '无上级';
      }
    },
    HandleOrderStatusClass(code, type) {
      let status = varCommon.orderStatus.pay[code],
        style = ''
      if (type === 'withdraw')
        status = varCommon.orderStatus.withdraw[code]

      switch (code) {
        case 0:
        case 1:
        case 2:
          if (type === 'withdraw')
            style = '000'
          style = '000'
          if (type === 'pay' && code !== 1)
            style = '00A600'
          if (type === 'pay' && code === 1)
            style = '000'
          break
        case 3:
          style = '00A600'
          break
        case 4:
        case 5:
        case 100:
          style = 'ff0000'
          break
        case 200:
        case 400:
          style = 'ff8500'
          break
      }
      return `<div style="color: #${style};">${status}</div>`
    },
    HandleSelectOption(obj) {
      let newArr = []
      for (const [key, value] of Object.entries(obj)) {
        newArr.push({ label: value, value: key })
      }
      return newArr
    },
    HandleRemoveKey(arr, kn, kv) {
      let newArr = []
      arr.forEach(key => {
        if (key[kn] !== kv)
          newArr.push(key)
      })
      return newArr
    },
    HandleIsEmptyObjValid(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
    },
    HandlePageQueryValid() {
      if (this.HandleIsEmptyObjValid(this.$route.query)) {
        return false
      } else {
        return true
      }
    },
    HandleTableStatusInActiveClass({ row }) {
      if (Object.prototype.hasOwnProperty.call(row, "status") && !row.status) {
        return 'table-status-inactive'
      }
      if (Object.prototype.hasOwnProperty.call(row, "hidden") && row.hidden) {
        return 'table-status-inactive'
      }
      if (Object.prototype.hasOwnProperty.call(row, "isDeleted") && row.isDeleted) {
        return 'table-status-inactive'
      }
      return ''
    },
    HandleTableStatusInActiveClassEnable({ row }) {
      return !row.enable ? 'table-status-inactive' : ''
    },
    HandleReadMore(s, len) {
      if (s && s.length > len + 1)
        return `${s.slice(0, len)}...`
      return s
    },
    HandleGetState(m, k) {
      return eval(`this.$store.state.${m}.${k}`)
    },
    HandleSetState(m, mt, o) {
      this.$store.commit(`${m}${mt}`, o)
    },
    HandleSlashValid(data) {
      return data.replace(/[/?]/g, '')
    },
    HandleEnglishNumberOnly(data) {
      let reg = /^[A-Za-z0-9]+$/
      if (!reg.test(data) && data)
        return false
      return true
    },
    // 自动补零
    HandleZero(s, len) {
      return String(s).padStart(len, '0')
    },
    HandleDeepCopy(row) {
      return JSON.parse(JSON.stringify(row))
    },
    // 接受 new Date() 的日期并返回 YYYY-MM-DD hh:mm:ss
    HandleDateYMDFormat(date) {
      let yy = date.getFullYear(),
        mm = this.HandleZero(date.getMonth() + 1, 2),
        dd = this.HandleZero(date.getDate(), 2),
        h = this.HandleZero(date.getHours(), 2),
        m = this.HandleZero(date.getMinutes(), 2),
        s = this.HandleZero(date.getSeconds(), 2)
      return `${yy}-${mm}-${dd} ${h}:${m}:${s}`
    },
    // 移除物件内有空的资料
    ObjectClean(obj) {
      for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
          delete obj[propName];
        }
      }
      return obj
    },
    // 增加会计符号格式化
    NumberWithCommas(x) {
      var parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    /* 复制文字
     text 作为要复制的文本
     NotificMsg 如果有传则作为提示语(不直接显示复制的内容)
    */
    CopyTextToClipboard(text, NotificMsg) {
      if (!navigator.clipboard) {
        this.FallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
        if (NotificMsg) {
          Notification.success(`${NotificMsg}`);
        } else {
          Notification.success(`已复制 ${text}`);
        }
      }, function (err) {
        Notification.error('复制失败: ', err);
      });
    },
    FallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? '成功' : '失败';
        Notification.success(`复制${msg}`);
      } catch (err) {
        Notification.error('复制失败: ', err);
      }
      document.body.removeChild(textArea);
    },
    // 浮点数相加
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // 浮点数相减
    accSubtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) { r1 = 0 }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      n = (r1 >= r2) ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    // 浮点数相乘
    accMul(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var m = 0;
        var s1 = arg1.toString();
        var s2 = arg2.toString();
        try {
          m += s1.split('.')[1].length;
        } catch (e) { () => { } }
        try {
          m += s2.split('.')[1].length;
        } catch (e) { () => { } }
        return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
      }
    },
    // 浮点数相除
    accDiv(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var t1, t2, r1, r2;
        try {
          t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
          t1 = 0;
        }
        try {
          t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
          t2 = 0;
        }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return this.accMul(r1 / r2, Math.pow(10, t2 - t1));
      }
    },
    // 产生随机生成密码
    generateRandomPassword() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";
      const length = 16;
      let randomString = "";
      let hasUpperCase = false;
      let hasLowerCase = false;
      let hasNumber = false;
      let hasSymbol = false;

      // 确保字串包含至少一个大写字母、一个小写字母、一个数字和一个符号
      while (!(hasUpperCase && hasLowerCase && hasNumber && hasSymbol)) {
        randomString = "";
        hasUpperCase = false;
        hasLowerCase = false;
        hasNumber = false;
        hasSymbol = false;

        // 随机产生指定数量的大写字母、小写字母、数字和特殊符号
        for (let i = 0; i < length; i++) {
          const randomIndex = Math.floor(Math.random() * chars.length);
          randomString += chars[randomIndex];

          if (/[A-Z]/.test(chars[randomIndex])) {
            hasUpperCase = true;
          } else if (/[a-z]/.test(chars[randomIndex])) {
            hasLowerCase = true;
          } else if (/[0-9]/.test(chars[randomIndex])) {
            hasNumber = true;
          } else {
            hasSymbol = true;
          }
        }
      }

      return randomString;
    },

    /* --- DF-202 --- */
    // 前后展示字串，其馀随机 "*" 字遮蔽
    maskedString(str) {
      if (!str) return;
      const thirdLength = Math.floor(str.length / 3);
      return str.substr(0, thirdLength) + "*".repeat(str.length - (thirdLength * 2)) + str.substr(-thirdLength);
    },
    // 地址比对
    overWriteAddress(originData, editData, type) {
      return editData.map((editItem, index) => {
        if (
          (type === "collect" && editItem.address.includes("*")) || // 若归集地址含 "*" 字元
          (type === "withdraw" && editItem.includes("*")) // 若提现地址含 "*" 字元
        ) {
          // 若为 "归集地址" 同时更新 "余额上限"
          if (type === "collect") {
            originData[index].amount = editItem.amount;
          }
          // 给 "原始" 地址(明码)
          return originData[index];
        } else {
          // 给 "编辑中" 地址
          return editItem;
        }
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/utils/methodCommon.js